
import Menu from './Compartido/Menu.jsx';
//import BuscadorDestino from './Destino/BuscadorDestino.jsx';
import PropiedadesDestino from './Destino/PropiedadesDestino.jsx';
import DatosDestino from './Destino/DatosDestino.jsx';
import Footer from './Compartido/Footer.jsx';

const Destino = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            {/* <BuscadorDestino
          destino = {props.eldestino}
          destinos = {props.destinos}
          tiposcasas = {props.tiposcasasdestino}
          lang = {props.lang}
          config = {props.websgrupo}
        /> */}
            <PropiedadesDestino
                destino={props.eldestino}
                lang={props.lang}
                ruta={props.ruta}
                propiedadesdestino={props.propiedadesdestino}
                config={props.websgrupo}
            />
            <DatosDestino
                destino={props.eldestino}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Destino;
